export default {
  addFlash(state, payload) {
    if ('object' !== typeof payload || null === payload) {
      return;
    }
    if (undefined === payload.type && undefined === payload.message) {
      return;
    }
    state.flashes.push(payload);
  },
  clearFlashes(state) {
    // eslint-disable-next-line
    state.flashes = [];
  },
  removeFlash(state, id) {
    // eslint-disable-next-line no-param-reassign
    state.flashes = state.flashes.filter((flash) => id !== flash.id);
  },
  flashesRef(state, ref) {
    state.flashesRef = ref;
  },
};
